import React from 'react';
import { Input } from 'antd';
import styles from './SearchBar.less';
import PropTypes from 'prop-types';

const propTypes = {
  action: PropTypes.oneOfType([PropTypes.func, PropTypes.array]).isRequired,
  toolbar: PropTypes.oneOfType([PropTypes.func, PropTypes.array]),
  options: PropTypes.object,
  onSearch: PropTypes.func,
};

const defaultProps = {
  toolbar: [],
  options: {},
  onSearch: () => {},
};

const Search = Input.Search;

export const SearchBar = (props) => {
  const { action, toolbar, options, onSearch } = props;
  // supports multiple search queries
  const actionIsArray = Array.isArray(action);
  const actionArray = actionIsArray ? action : [action];

  const handleSearch = (value) => {
    onSearch(value);
    actionArray.forEach((action) => {
      action(1, value, options);
    });
  };

  return (
    <div className={styles.searchBarContainer}>
      <Search
        allowClear
        className={styles.searchBar}
        enterButton="Search"
        onSearch={(value) => handleSearch(value)}
        placeholder={(options && options.placeholder) || ''}
      />
      {toolbar && typeof toolbar === 'function' && toolbar()}
      {toolbar &&
        Array.isArray(toolbar) &&
        toolbar.map((Button, i) => (
          <div className={styles.toolbarButton} key={i}>
            <Button />
          </div>
        ))}
    </div>
  );
};

SearchBar.propTypes = propTypes;
SearchBar.defaultProps = defaultProps;

export default SearchBar;
